import React, { useState } from 'react';
import { type ApolloQueryResult } from '@apollo/react-hooks';
import {
  Select,
  Alert,
  type AlertDetails,
  type SelectOption,
} from '../../../../../components';
import { useUpdateAssignee } from '../../../graphql';
import { type ApplicationViewTableDataItem } from '../../../../Application/components';

export const assignee = (
  row: ApplicationViewTableDataItem,
  gsAssigneeOption: SelectOption[],
  refetch: () => Promise<ApolloQueryResult<any>>,
): React.ReactNode => {
  const { gsAssignee } = row;

  const [alertDetails, setAlertDetails] = useState<AlertDetails>({
    alertContent: '',
    alertType: 'error',
  });
  const [openAlert, setOpenAlert] = useState<boolean>(false);

  const updateAssignee = useUpdateAssignee();
  const handleUpdateAssignee = async (
    row: ApplicationViewTableDataItem,
    e: React.ChangeEvent<{ value: unknown }>,
  ): Promise<void> => {
    try {
      const variables = {
        input: {
          applicationId: row.applicationId,
          assignee: e.target.value as string,
        },
      };
      await updateAssignee({ variables });
      await refetch();
      setAlertDetails({
        alertContent: 'Assignee Updated successfully',
        alertType: 'success',
      });
    } catch (error) {
      setAlertDetails({
        alertContent: 'Failed to assign result',
        alertType: 'error',
      });
    }
    setOpenAlert(true);
  };

  return (
    <>
      <Alert
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        alertDetails={alertDetails}
      />
      <Select
        options={gsAssigneeOption}
        size="small"
        value={gsAssignee ?? ''}
        fullWidth
        onChange={async e => {
          await handleUpdateAssignee(row, e);
        }}
      />
    </>
  );
};
